<template>
  <a-modal
        :maskClosable="false"
          title="平台抽成配置"
          :width="1000"
          :style="{'top':'10px'}"
          :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
          v-model="visibleModel"
          @cancel="handleCancel"
          @ok="handleOk"
  >
    <a-spin :spinning="saveLoading">
      <a-form :form="form">


        <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="规则配置"
                hasFeedback
        >
          <a-radio-group v-model="formData.reward_setting_mode" buttonStyle="solid">
            <a-radio-button :value="1">以全局配置为准</a-radio-button>
            <a-radio-button :value="2">该商品单独配置</a-radio-button>
          </a-radio-group>
        </a-form-item>


        <div v-show="formData.reward_setting_mode==2">

          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="商品模式"
                  hasFeedback
          >
            <a-radio-group v-model="formData.reward_goods_mode" buttonStyle="solid">
              <a-radio-button :value="1">按商品整体配置</a-radio-button>
              <a-radio-button :value="2">按每个sku配置</a-radio-button>
            </a-radio-group>
          </a-form-item>

          <a-form-item
                  v-show="formData.reward_goods_mode==1"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="平台抽成"
                  hasFeedback
                  extra="完成订单实际支付商品金额的千分之几,用户订单成交后收取的手续费
"
          >
            <a-input type="number" v-decorator="[
          'reward_percent',
          {rules: [{ required: true, message: '请输入比例' }]}
        ]"
                     placeholder="请输入比例"/>
          </a-form-item>

          <a-table
                  v-show="formData.reward_goods_mode==2 && skuTable.sku_list.length"
                  :columns="skuColumns"  :dataSource="skuTable.sku_list" :pagination="false" rowKey="key"  bordered>
            <template slot="reward">
              <a-popconfirm okText="确定" cancelText="取消" @confirm="setAllReward">
                <span slot="icon" />
                <template slot="title">
                  <PriceInput
                          :formData="setAll"
                          field="setAllRewardValue"
                          placeholder="批量设置线上提成(元)"/>
                  <!--<a-input-->
                          <!--v-model="setAllRewardValue"-->
                          <!--placeholder="批量设置线上提成" />-->
                </template>
                线上提成 <a-icon type="form" />
              </a-popconfirm>
            </template>
            <template slot="rewardOffline">
              <a-popconfirm okText="确定" cancelText="取消" @confirm="setAllRewardOffline">
                <span slot="icon" />
                <template slot="title">
                  <PriceInput
                          :formData="setAll"
                          field="setAllRewardOfflineValue"
                          placeholder="批量设置线下提成(元)"/>
                  <!--<a-input-->
                          <!--v-model="setAllRewardOfflineValue"-->
                          <!--placeholder="批量设置线下提成" />-->
                </template>
                线下提成 <a-icon type="form" />
              </a-popconfirm>
            </template>
            <template slot="id" slot-scope="text,record,index">
              <a-input v-model="record.id" placeholder="id"/>
            </template>
            <template slot="reward" slot-scope="text,record,index">

              <PriceInput
                          :formData="record"
                          field="reward"
                          placeholder="线上提成(元)"/>
              <!--<a-input v-model="record.reward" placeholder="线上提成(元)"/>-->
            </template>
            <template slot="reward_offline" slot-scope="text,record,index">
              <PriceInput
                      :formData="record"
                      field="reward_offline"
                      placeholder="线下提成(元)"/>
              <!--<a-input v-model="record.reward_offline" placeholder="线下提成(元)"/>-->
            </template>
          </a-table>

        </div>


      </a-form>

    </a-spin>
    <template slot="footer">
      <a-button key="cancel" @click="handleCancel">取消</a-button>
      <a-button key="forward" :loading="saveLoading" type="primary" @click="handleOk">保存</a-button>
    </template>
  </a-modal>
</template>

<script>
  import RSwitch from '@/components/RSwitch/'
  import { getDealtownRewardSetting,dealtownRewardSetting } from '@/api/goods'
  import PriceInput from '@/components/PriceInput/'
  export default {
    name: 'GoodsDealtownRewardForm',
    components: {
      RSwitch,PriceInput
    },
    props: {
      goodsId:{
        type: String|Number,
        required: true
      },
      visible:{
        type: Boolean,
        default:false
      }
    },
    data () {
      return {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12 },
        },
        form: this.$form.createForm(this),
        goods:{
          id:this.$route.query.id
        },
        saveLoading:false,
        setAll:{
          setAllRewardValue:undefined,
          setAllRewardOfflineValue:undefined,
        },
        formData:{
          goods_id:0,
          reward_setting_mode:1,
          reward_goods_mode:1,
          reward_percent:0,
          sku:[],
          sku_list:[]
        },
        sellerGroupSelectValue:undefined,
        sku_fields_list:[],
        skuTable:{
          sku_fields_sets:[],
          sku_list:[],
        },
      }
    },
    watch: {
      goodsId(value){
        let that = this
        if(value){
          that.getDealtownRewardSetting();
        }
      }
    },
    methods: {
      setAllReward(){
        let that = this;
        that.skuTable.sku_list.map(item =>{
            item.reward = that.setAll.setAllRewardValue;
        });
        that.setAll.setAllRewardValue = undefined;
      },
      setAllRewardOffline(){
        let that = this;
        that.skuTable.sku_list.map(item =>{
          item.reward_offline = that.setAll.setAllRewardOfflineValue;
        });
        that.setAll.setAllRewardOfflineValue = undefined;
      },
      handleOk(e){
        let self = this
        e.preventDefault()
        this.form.validateFields((err, values) => {
          if (!err) {
            self.saveLoading = true;
            console.log('Received values of form: ', values)
            console.log('Received valuess of formData: ', self.formData)
            self.formData.goods_id = self.goodsId;
            self.formData.sku_list = self.skuTable.sku_list
            dealtownRewardSetting(Object.assign(self.formData,values)).then(res => {
              self.$message.success('设置成功')
              self.saveLoading = false;
              this.$emit('dealtownRewardDone')
            }).catch(err =>{
              self.$message.error(err.data.msg);
              self.saveLoading = false;
            })
          }else{
            console.log(err);
          }
        })
      },
      handleCancel(){
        this.$emit('dealtownRewardDone')
      },

      getDealtownRewardSetting(){
        let that = this
        getDealtownRewardSetting({ goods_id: that.goodsId }).then(res => {
          that.formData = res.data;
          that.form.setFieldsValue({...res.data});
          that.formData.sku = res.data.sku;
          that.sku_fields_list = res.data.sku_fields_list;
          that.refreshSkuList();
        }).catch(err =>{
          that.$message.error(err.data.msg)
        })
      },

      refreshSkuList(){
        let self = this;
        var sets = [];
        var skulist = [];
        var count = [];
        if(this.sku_fields_list.length==0 || this.sku_fields_list[0].attrs.length==0){
          return {
            'sku_fields_sets' : sets,
            'sku_list' : skulist,
          }
        }
        for(var i = this.sku_fields_list.length-1 ; i >=0 ; i-- ){
          var key = this.sku_fields_list.length-1-i;
          var rkey = i;
          var list = [];
          var len = this.sku_fields_list[i].attrs.length;
          if(i-1>=0){
            count[i-1] = len * ( count[i] ? count[i] : 1);
          }

          sets[key] = [];
          if (key == 0) {
            for(var l = 0 ; l<this.sku_fields_list[key].attrs.length ; l++ ){
              sets[key].push({
                'id' : this.sku_fields_list[key].attrs[l].id,
                'title' : this.sku_fields_list[key].attrs[l].title,
                'sku' : [{
                  'field_id': this.sku_fields_list[key].id,
                  'attr_id': this.sku_fields_list[key].attrs[l].id,
                  'attr_title': this.sku_fields_list[key].attrs[l].title,
                }]
              })
            }
          } else {
            var ccount =  sets[key-1].length;
//                        console.log('ccount');
//                        console.log(ccount);
            for(var n = 0; n < ccount ; n++) {
              for(var j= 0; j <  this.sku_fields_list[key].attrs.length ; j++){
                var sku = sets[key-1][n]['sku'];
                sets[key].push(
                        {
                          'id' : this.sku_fields_list[key].attrs[j].id,
                          'title' : this.sku_fields_list[key].attrs[j].title,
                          'sku' : sku.concat({
                            'field_id': this.sku_fields_list[key].id,
                            'attr_id': this.sku_fields_list[key].attrs[j].id,
                            'attr_title': this.sku_fields_list[key].attrs[j].title,
                          })
                        }
                )
              }
//                            sets[key] = sets[key].concat(this.sku_fields_list[key].attrs);
            }
//                        console.log('set');
//                        console.log(sets[key]);
          }
        }

        for( var k = 0 ; k < sets.length ; k++){
          for(var index = 0 ; index < sets[k].length ;  index++){
            sets[k][index].height = count[k] ? count[k] : 1;
          }
        }
        if(sets[sets.length-1].length==0){
          sets.splice(sets.length-1,1);
        }
        for(var m=0; m< sets[sets.length-1].length ; m++){
          var row = {
            'key' : 'm'+m,
            'id' : 0,
            'code' : '',
            'price' : 0,
            'reward' : 0,
            'reward_offline' : 0,
            'cost_price' : 0,
            'sold_count' : 0,
            'unit_count' : 1,
            'stock' : 0,
            'popoverVisible' : false,
            'sku' : sets[sets.length-1][m].sku,
            'height' : sets[sets.length-1][m].height
          };
          for(var p = 0 ; p < this.formData.sku.length ; p ++){
            let skuArray = [];
            sets[sets.length-1][m].sku.map(skuItem =>{
              skuArray.push({
                field_id: skuItem.field_id,
                attr_id: skuItem.attr_id,
              })
            });
            console.log('skuArray');
            console.log(skuArray);
            if(JSON.stringify(this.formData.sku[p].sku).replace(/"/g,'') == JSON.stringify(skuArray).replace(/"/g,'')){
              row = {
                'key':'p'+p,
                'id' : this.formData.sku[p].id,
                'code' : this.formData.sku[p].code,
                'price' : this.formData.sku[p].price,
                'cost_price' : this.formData.sku[p].cost_price,
                'sold_count' : this.formData.sku[p].sold_count,
                'unit_count' : this.formData.sku[p].unit_count,
                'reward' : this.formData.sku[p].reward,
                'reward_offline' : this.formData.sku[p].reward_offline,
                'stock' : this.formData.sku[p].stock,
                'popoverVisible' : false,
                'sku' : sets[sets.length-1][m].sku,
                'height' : sets[sets.length-1][m].height
              };
              break ;
            }
          }
          skulist.push(row);
        }
        console.log('skulist')
        console.log(skulist)
        self.skuTable = {
          sku_fields_sets:sets,
          sku_list:skulist,
        }
      },
    },
    computed:{
      visibleModel:{
        get: function () {
          return this.visible;
        },
        set: function () {
        }
      },
      skuColumns(){
        let self = this;
        let skuColums = [];
        self.sku_fields_list.map((item,index) =>{
          if(item.attrs.length ==0){
            return;
          }
          skuColums.push({
            title: ''+item.title,
            width: 100,
            dataIndex: 'sku['+index+'].attr_title',
            customRender: (value, row, index2) => {
              const obj = {
                children: value,
                attrs: {},
              };
              let rowSpan = self.skuTable.sku_fields_sets[index][0].height;
              if(index2 % rowSpan ==0){
                obj.attrs.rowSpan = rowSpan;
              }else{
                obj.attrs.rowSpan = 0;
              }
              return obj;
            }
          });
        });
        let constColums =  [
          {
            width: 100,
            dataIndex: 'price',
            title:'原价',
            customRender: (text) =>  {
                  return parseFloat(text).toFixed(2);
            }
          },
          {
            width: 100,
            dataIndex: 'seller_reward',
            slots: { title: 'reward' },
            scopedSlots: { customRender: 'reward' }
          },
          {
            width: 100,
            dataIndex: 'team_reward',
            slots: { title: 'rewardOffline' },
            scopedSlots: { customRender: 'reward_offline' }
          },
          {
            width: 100,
            title:'成本',
            dataIndex: 'cost_price',
                  customRender: (text) =>  {
            return parseFloat(text).toFixed(2);
          }
          },
        ];
        return skuColums.concat(constColums);
      }
    },
  }
</script>

<style lang="less" scoped>
</style>